export default function Loading() {
  return (
    <div className="loading-box">
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  )
}